import { post } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { useMutation, type UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import {
  type AddSignatureRequest,
  addSignatureRequestSchema,
  type AddSignatureResponse,
  addSignatureResponseSchema,
} from "../types";
import { getSignaturesQueryKey } from "./useSignatures";

export const ADD_SIGNATURE_URL = `${environmentConfig.REACT_APP_HOME_HEALTH_API_URL}/v1/signatures`;

export function useAddSignature(
  options: UseMutationOptions<AddSignatureResponse, string, AddSignatureRequest> = {}
) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (params) => {
      const response = await post({
        url: ADD_SIGNATURE_URL,
        data: params,
        requestSchema: addSignatureRequestSchema,
        responseSchema: addSignatureResponseSchema,
      });
      return response.data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries(getSignaturesQueryKey());
    },
    ...options,
  });
}
